import { useEffect } from 'react';
import { useParams } from 'react-router';

import { ToolEntryResolver } from '@/component/Tool';
import { SHORTCUT_CONST } from '@/constant';
import { useSuperObjectClassListQuery } from '@/hook';
import { trackIDManager } from '@/manager';
import { useShortcut } from '@/package';
import { NEW__labelingBoxPool } from '@/util';

const TaskPage = () => {
  const pathParam = useParams<{
    projectId: string;
    taskId: string;
    frameSeq: string;
  }>();
  const { switchNamespace } = useShortcut();

  useSuperObjectClassListQuery();

  useEffect(() => {
    switchNamespace?.(SHORTCUT_CONST.SHORTCUT_NAMESPACE.LABELING);

    return () => {
      NEW__labelingBoxPool.disposeAllLabelingBox();
      trackIDManager.cleanup();

      switchNamespace?.(SHORTCUT_CONST.SHORTCUT_NAMESPACE.DEFAULT);
    };
  }, []);

  return <ToolEntryResolver {...pathParam} />;
};

export default TaskPage;
